import React, { createContext, useContext, useState } from 'react';

const AnalyticsContext = createContext();

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};

export const AnalyticsProvider = ({ children }) => {
  const [events, setEvents] = useState([]);

  const trackEvent = (eventName, eventData = {}) => {
    const newEvent = {
      id: events.length + 1,
      name: eventName,
      data: eventData,
      timestamp: new Date()
    };
    
    setEvents(prevEvents => [...prevEvents, newEvent]);
    
    // Log to console for development
    console.log(`Analytics Event: ${eventName}`, eventData);
    
    // In a real implementation, you would send this to your analytics service
    // Example: firebase.analytics().logEvent(eventName, eventData);
  };

  const value = { trackEvent, events };
  
  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  );
};